import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from './zh.json';
import en from './en.json';

Vue.use(VueI18n);

const STORAGE_KEY = 'lang';

function detectLocale() {
  if (typeof localStorage !== 'undefined') {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return saved;
  }
  if (typeof navigator !== 'undefined') {
    const lang = navigator.language || navigator.userLanguage || '';
    if (lang.toLowerCase().includes('zh')) return 'zh';
  }
  return 'en';
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: 'zh',
  messages: { zh, en }
});

export function setLocale(locale) {
  if (!locale) return;
  i18n.locale = locale;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, locale);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', locale);
  }
}

// 初始化 html lang
setLocale(i18n.locale);

export default i18n;

